import React, { useRef, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import "./styles.scss";
import avatar from "../../Assets/svg/avatar-img.svg";

// import required modules
// import { Pagination, Navigation } from 'swiper/modules';
import { Pagination, Navigation, HashNavigation } from "swiper/modules";
import { useSelector } from "react-redux";

export default function ImageCarousel(props) {
  const [swiperRef, setSwiperRef] = useState(null);
  const alumni = useSelector((state) => state.connect.alumnis);

  return (
    <>
      <Swiper
        spaceBetween={30}
        hashNavigation={{
          watchState: true,
        }}
        // pagination={{
        //   clickable: true,
        // }}
        navigation={true}
        modules={[Pagination, Navigation, HashNavigation]}
        className="mySwiper"
        onSlideChange={(e) => props.setId(alumni[e.activeIndex])}
      >
        {alumni?.map((item, index) => {
          return (
            <SwiperSlide>
              {" "}
              <ProfilePicture name={item?.fullName || item?.name || ''} />
            </SwiperSlide>
          );
        })}
      </Swiper>
    </>
  );
}

const ProfilePicture = ({ name }) => {
  // Extract the first letter of the name
  const firstLetter = name?.charAt(0)?.toUpperCase() || '';

  // Inline styles for the profile picture
  const styles = {
    container: {
      borderRadius: "50%",
      backgroundColor: "rgb(0, 123, 255)",
      /* color: rgb(255, 255, 255); */
      /* font-size: 24px; */
      /* font-weight: bold; */
      textAlign: "-webkit-center",
      display: "block",
      maxHeight: "10em",
      minHeight: "10em",
      maxWidth: "10em",
      width: "100%",
      height: "100%",
      objectFit: "cover",
    },
    spanContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      height: "1.8em",
      borderRadius: "50%",
      /* background-color: rgb(0, 123, 255); */
      color: "rgb(255, 255, 255)",
      fontSize: "97px",
      fontWeight: "bold",
    },
  };

  return (
    <div style={styles.container}>
      <span style={styles.spanContainer}> {firstLetter}</span>
    </div>
  );
};
